<template>
    <span class="inline-choice" :style="{ '--blank': `'${placeholder}'` }">
        <span v-if="options.length <= inlineMax" class="choice-chips">
            <button
                v-for="[value, label] in options"
                :id="id ? `${id}-${value}` : null"
                :key="value"
                type="button"
                :class="[
                    'choice-chip',
                    {
                        active: value === modelValue,
                        disabled: disabledOptions[value],
                    },
                ]"
                :title="disabledOptions[value] || null"
                :aria-disabled="Boolean(disabledOptions[value])"
                @click="choose(value)"
            >
                {{ label }}
            </button>
        </span>
        <Dropdown
            v-else
            :id="id"
            :model-value="modelValue"
            :group="group"
            nullable
            @update:model-value="$emit('update:modelValue', $event)"
        />
    </span>
</template>
<script>
export default {
    name: "InlineChoice",
    props: {
        id: {
            type: String,
            default: null,
        },
        group: {
            type: String,
            required: true,
        },
        modelValue: {
            type: [String, null],
            required: true,
        },
        placeholder: {
            type: String,
            default: "any",
        },
        inlineMax: {
            type: Number,
            default: 6,
        },
        disabledOptions: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ["update:modelValue"],
    computed: {
        options() {
            return this.$enumOptions(this.group);
        },
    },
    methods: {
        choose(value) {
            if (this.disabledOptions[value]) {
                return;
            }
            this.$emit(
                "update:modelValue",
                value === this.modelValue ? null : value
            );
        },
    },
};
</script>
